import { Checkbox } from "pepsico-ds";
import {
  formatDate,
  truncateArray,
  truncateText,
} from "../../../../../utils/function";

import { useEffect, useMemo, useState } from "react";
import DynamicTable from "../../../../../utils/Table/DynamicTable";

const columns = [
  { id: "actions", label: " ", width: "80px" },
  {
    label: "ITEM TITLE",
    id: "title",
    width: "225px",
  },
  {
    label: "ITEM TYPE",
    id: "type",
    width: "225px",
  },
  {
    label: "DATE CREATED",
    id: "createdDate",
    width: "225px",
  },
  {
    label: "LAST MODIFIED",
    id: "lastModifiedDate",
    width: "225px",
  },
  {
    label: "SUBJECT",
    id: "newSubject",
  },
];

const SelectionTable = ({
  onSelection,
  selectedRows = [],
  type,
  search,
  subject,
  rowData,
  loading,
}) => {
  // const [rowData, setRowData] = useState(dummData[type]);
  const [selectedIds, setSelectedIds] = useState([]);
  useEffect(() => {
    const ids = selectedRows.map((row) => row.contentId || row.id);
    setSelectedIds(ids);
  }, [selectedRows]);

  const formattedData = useMemo(() => {
    let filtered = [...rowData];

    if (subject?.label) {
      filtered = filtered.filter((item) =>
        item.subject?.includes(subject.label)
      );
    }

    const data = filtered.map((item) => ({
      ...item,
      id: item.contentId || item.id, // unique per row globally
      newSubject: truncateArray(item.subject),
      createdDate: formatDate(item.createdDate),
      lastModifiedDate: formatDate(item.lastModifiedDate),
    }));
    return data;
  }, [rowData, selectedRows, subject, type]);

  const handleCheckboxChange = (contentId) => {
    setSelectedIds((prev) => {
      const newSelectedIds = prev.includes(contentId)
        ? prev.filter((id) => id !== contentId)
        : [...prev, contentId];

      const selectedItems = rowData.filter((item) =>
        newSelectedIds.includes(item.contentId)
      );

      onSelection(selectedItems);
      return newSelectedIds;
    });
  };

  const renderActions = (row) => {
    const isSelected = selectedIds.includes(row.contentId);

    return (
      <Checkbox
        checked={isSelected}
        data-testid="checkbox"
        onClick={(e) => {
          e.stopPropagation(); // avoid triggering row click
          handleCheckboxChange(row.contentId);
        }}
      />
    );
  };

  return (
    <DynamicTable
      searchText={search}
      rows={formattedData}
      columns={columns}
      renderActions={(row) => renderActions(row)}
      onRowClick={() => {}}
      loading={loading}
    />
  );
};

export default SelectionTable;
